import React, { Component } from 'react';
import './App.css';
import Latlng from "react-input-latlng";

class App extends Component {
    state = {lat: 36.345, lng: -2.344, decimal: false};

	updatePoint(lat, lng) {
	    console.log(lat, lng);
    }
  render() {
    return (
      <div className="">
        <header className="">
            <h1>Latitude/Longitude masked input example</h1>

            <div><Latlng style={{border: "1px solid grey"}} lat={this.state.lat} lng={this.state.lng} onChange={(lat,lng) => this.updatePoint(lat,lng)} decimal={this.state.decimal}/></div>

            <div><button onClick={() => this.setState({decimal: !this.state.decimal})}>Switch decimal format</button></div>

            <p><small><i>Open de console to see the onChange event</i></small></p>
        </header>
      </div>
    );
  }
}

export default App;
